import { SubMenu as LegacyBillingSubMenu } from 'billing/components';
import BillingSubMenu from 'billing/components/BillingSubMenu';
import { FullHeightCalculatorHOC } from 'common-js/components';
import useAppSelector from 'common-js/hooks/useAppSelector';
import { getBalance } from 'common-js/reducers/organization/selectors';
import { type FC, type ReactNode } from 'react';
import { type RouteComponentProps } from 'react-router';
import BaseLayout from './BaseLayout';

interface LayoutBillingProps extends RouteComponentProps<{}, RouterQueryParams> {
  children?: ReactNode;
}

const LayoutBilling: FC<LayoutBillingProps> = ({ children, location, ...rest }) => {
  const balance = useAppSelector(getBalance);

  return (
    <BaseLayout location={location} {...rest}>
      {balance.billingVersion === 2 ? (
        <BillingSubMenu pathname={location.pathname} />
      ) : (
        <LegacyBillingSubMenu pathname={location.pathname} />
      )}
      <FullHeightCalculatorHOC accountForDrawer>
        <div className="container">
          <FullHeightCalculatorHOC classNames="fullHeight-usage" accountForDrawer relative>
            {children}
          </FullHeightCalculatorHOC>
        </div>
      </FullHeightCalculatorHOC>
    </BaseLayout>
  );
};
export default LayoutBilling;
